var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOhio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.651,112.621l-12.013-73.74l-27.343,12.43l-19.473,20.713c0,0-31.38,8.698-33.087,9.734 c-1.709,1.036-8.751-7.665-8.751-7.665l-12.843,4.569l-13.153-7.779l-32.341,4.402l-24.83,3.377l15.845,145.707 c2.799-1.553,13.982-6.212,16.158-4.971c0.221,0.124,0.512,0.4,0.847,0.781c2.97,3.348,9.907,15.375,11.582,15.375 c1.863,0,18.331,5.594,21.746,4.972c3.42-0.622,13.362-3.106,13.362-3.106l5.281,4.659c0,0,5.006-4.423,9.319-7.784 c2.73-2.127,5.182-3.832,5.904-3.712c1.865,0.312,2.797,9.013,2.797,9.013l11.808,7.768l0.401,2.533l9.544-3.881l2.069-9.529 l3.314-1.242c0,0,0.413-22.783,4.559-22.783c4.141,0,7.041,4.555,7.041,4.555l5.385-4.971l-4.142-7.457l12.428-19.056l7.455,0.413 c0,0,3.324-3.648,7.065-8.109c4.72-5.627,10.104-12.547,10.334-15.088c0.416-4.557,1.66-37.698,1.66-37.698l-4.973-9.115 L235.651,112.621z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOhio);
export default __webpack_public_path__ + "static/media/ohio.d1b242f9812cdb632b317d9d5ec49f7c.svg";
export { ForwardRef as ReactComponent };